import { useMutation } from "react-query";
import userAccessPermissionService from "../../services/userAccessPermissionService";

const useAddUserAccessPermission = () =>
  useMutation(userAccessPermissionService.create);

export default useAddUserAccessPermission;
